export enum SleepQuestionnairesValidationType {
    essDraft = 'essDraft',
    essFinal = 'essFinal',
    fosq10Draft = 'fosq10Draft',
    fosq10Final = 'fosq10Final',
    hsdqDraft = 'hsdqDraft',
    hsdqFinal = 'hsdqFinal',
}
